import * as types from '../constants/actionTypes';

export const fetchProducts = () => ({
  type: types.FETCH_PRODUCTS_REQUEST
});

export const fetchProductsSuccess = (products) => ({
  type: types.FETCH_PRODUCTS_SUCCESS,
  payload: products
});

export const fetchProductsFailure = (error) => ({
  type: types.FETCH_PRODUCTS_FAILURE,
  payload: error
});

export const createProduct = (productData) => ({
  type: types.CREATE_PRODUCT_REQUEST,
  payload: productData
});

export const createProductSuccess = (product) => ({
  type: types.CREATE_PRODUCT_SUCCESS,
  payload: product
});

export const createProductFailure = (error) => ({
  type: types.CREATE_PRODUCT_FAILURE,
  payload: error
});

export const updateProduct = (id, productData) => ({
  type: types.UPDATE_PRODUCT_REQUEST,
  payload: { id, productData }
});

export const updateProductSuccess = (product) => ({
  type: types.UPDATE_PRODUCT_SUCCESS,
  payload: product
});

export const updateProductFailure = (error) => ({
  type: types.UPDATE_PRODUCT_FAILURE,
  payload: error
});

export const getProduct = (id) => ({
  type: types.GET_PRODUCT_REQUEST,
  payload: id
});

export const getProductSuccess = (product) => ({
  type: types.GET_PRODUCT_SUCCESS,
  payload: product
});

export const getProductFailure = (error) => ({
  type: types.GET_PRODUCT_FAILURE,
  payload: error
});

// Product Form Data Actions
export const fetchProductFormData = () => ({
  type: types.FETCH_PRODUCT_FORM_DATA_REQUEST
});

export const fetchProductFormDataSuccess = (formData) => ({
  type: types.FETCH_PRODUCT_FORM_DATA_SUCCESS,
  payload: formData
});

export const fetchProductFormDataFailure = (error) => ({
  type: types.FETCH_PRODUCT_FORM_DATA_FAILURE,
  payload: error
});